<template>
  <div class="shoppingcar" :class="current_theme">
    <div class="shoppingcarbody container" v-show="show_car">
      <h2 class="title_font2">{{ $t("cart.your_cart") }}</h2>
      <v-line></v-line>
      <div v-if="!cartmes.cart_contents_count || error">
        <div v-if="error">
          <p class="page_text_font">{{ error }}</p>
        </div>
        <div v-else class="cartEmpty">
          <img class="cartEmpty--image" :src="require('@/images/cartEmpty.png').default" alt />
          <p class="page_text_font">{{ $t("cart.cart_empty") }}</p>
          <p class="page_text_font">
            {{ $t("cart.cart_browse") }}
            <a class="page_text_font" href="/collections/all">{{
              $t("cart.cart_here")
            }}</a>
          </p>
        </div>
      </div>
      <div class="shoppingcarbodylist col-md-10 offset-md-1 col-12" v-else>
        <div class="row shoppingcarbodylisthead">
          <div class="col-md-7 col-12"></div>
          <div class="col-md-5 col-12 numprice">
            <div class="row row_sm">
              <div class="col-md-4 col-4 secondary_title">
                {{ $t("cart.quantity") }}
              </div>
              <div class="col-md-8 text-right secondary_title">
                {{ $t("cart.total") }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-for="item in cartmes.cart"
          :key="item.key"
          class="row shoppingcarbodylistitem"
          :class="{
            'free-box':item.wdr_free_product=='Free'
          }"
        >
          <div class="col-md-2 col-4">
            <a :href="item.product.path || item.product.public_url">
              <img
                :src="
                  item.variant
                    ? item.variant.feature_image
                      ? item.variant.feature_image.thumbnail
                      : item.product.feature_image
                      ? item.product.feature_image.thumbnail
                      : defaultImage
                    : item.product.feature_image
                    ? item.product.feature_image.thumbnail
                    : defaultImage
                "
                @error.once="imageFailure($event, defaultImage)"
                width="100%"
                :class="[themeStyleRadius == 'circle' ? 'image-radius' : '']"
                class="lazyload"
              />
            </a>
          </div>
          <div class="col-md-5 col-8 text-left">
            <a :href="item.product.path || item.product.public_url">
              <p class="page_text_font">{{ item.product.post_title }}</p>
              <p class="variant" v-if="item.variant">
                <template v-for="(subitem, subindex) in item.variant.attrs">
                  <span
                    class="secondary_title"
                    v-if="subitem.value != 'Default Title'"
                    :key="subitem + subindex"
                    >{{ subitem.value }}</span
                  >
                </template>
              </p>
              <template v-if="item.properties">
              <template v-for="(subitem, subindex) in item.properties">
                <p
                  class="variant text-overflow-1"
                  v-if="subitem"
                  :key="subindex + subitem"
                >
                  <span class="secondary_title"> {{ subindex }} :
                    <template v-if="subitem.search(/^https?:\/\//)==-1">  {{ subitem }} </template>
                    <a class="preview" v-else :href="subitem" @click.prevent="downloadFile(subitem,subitem)">Preview</a>
                  </span>
                </p>
              </template>
              </template>
            </a>
          </div>
          <div class="col-md-5 col-12 numprice">
            <div class="row row_sm">
              <div class="col-md-4 col-4 total_sm">
                <my-el-input-number
                  :class="[themeStyleRadius == 'circle' ? 'button-radius' : '']"
                  v-model="item.quantity"
                  :max="100000"
                  :precision="0"
                  :step="1"
                  step-strictly
                  :disabled="disabled_num"
                  @change="
                    changequantity(
                      item.quantity,
                      item.key,
                      item.product_id,
                      item.variation_id
                    )
                  "
                ></my-el-input-number>
                <a
                  class="secondary_title"
                  href="#"
                  @click.stop.prevent="changequantity(0,item.key,product_id,variant_id)"
                  >{{ $t("cart.remove") }}
              </a>
              </div>
              <div class="col-md-8 text-md-right selet_sm">
                <v-selectprice
                  id="discount_price"
                  v-if="item.line_subtotal - 0 > item.line_total - 0"
                  :price="item.line_subtotal"
                  fontSize="14"
                  :disable_select="true"
                  :country="$store.state.pricetype"
                ></v-selectprice>
                <v-selectprice
                  :price="item.line_total"
                  fontSize="14"
                  :disable_select="!(showCurrencySelector && currencySelectorType == 'global')"
                  :appendToBody="false"
                ></v-selectprice>
              </div>
            </div>
          </div>
          <div class="free-item" v-if="item.wdr_free_product=='Free'">
            <div class="free-label venue_sales_label">Giveaway</div>
            <div class="image-box">
                <a :href="item.product.path || item.product.public_url">
                  <img
                    :src="
                      item.variant
                        ? item.variant.feature_image
                          ? item.variant.feature_image.thumbnail
                          : item.product.feature_image
                          ? item.product.feature_image.thumbnail
                          : defaultImage
                        : item.product.feature_image
                        ? item.product.feature_image.thumbnail
                        : defaultImage
                    "
                    @error.once="imageFailure($event, defaultImage)"
                    width="100%"
                    class="lazyload"
                  />
                </a>
            </div>
            <div class="text-box">
              <a :href="item.product.path || item.product.public_url">
                <p class="page_text_font text-item">{{ item.product.post_title }}</p>
                <p class="variant text-item" v-if="item.variant">
                  <template v-for="(subitem, subindex) in item.variant.attrs">
                    <span
                      class="secondary_title"
                      v-if="subitem.value != 'Default Title'"
                      :key="subitem + subindex"
                      >{{ subitem.value }}</span
                    >
                  </template>
                </p>
              </a>
              <div>
                <v-selectprice
                  id="free-price"
                  :price="(item.line_total/item.quantity).toFixed(2)"
                  :disable_select="true"
                  :country="$store.state.pricetype"
                  :fontSize="12"
                ></v-selectprice>
                <span>x {{item.quantity}} </span>
              </div>
            </div>
          </div>
        </div>
        <div class="foot">
          <div>
            <!-- 总计 -->
            <div class="shoppingcarbodylistfoot" v-if="cartmes.discount_cart">
              <div
                style="position: relative; margin: 0"
                class="row justify-content-between text-md-right text-center "
              >
                <div class="subtotal secondary_title secondary_unset">
                  {{ $t('account.subtotal') }}
                </div>
                <div style="margin-left: 8px;">
                  <v-selectprice
                    :price="(complete_subtotal + (cartmes.discount_cart || 0)).toFixed(2)"
                    :disable_select="true"
                    fontSize="14"
                    :appendToBody="false"
                  ></v-selectprice>
                </div>
              </div>
            </div>

            <!-- 优惠金额 -->
            <div
              class="shoppingcarbodylistfoot"
              style="border-top:0 !important;"
              v-if="cartmes.discount_cart"
            >
              <div
                style="position: relative; margin: 0"
                class="
                  row
                   justify-content-between
                  text-md-right text-center
                "
              >
                <div class="subtotal secondary_title secondary_unset">
                  {{ $t('account.discount') }}
                </div>
                <div style="margin-left: 8px;">
                  <v-selectprice
                    :price="cartmes.discount_cart"
                    :disable_select="true"
                    fontSize="14"
                    class="secondary-minus"
                  />
                </div>
              </div>
            </div>
            <div class="shoppingcarbodylistfoot default_shoppingcarbodylistfoot" :class="{'only_default_shoppingcarbodylistfoot': !cartmes.discount_cart }">
              <div
                style="position: relative; margin: 0"
                class="row justify-content-between text-md-right text-center "
              >
                <div class="subtotal secondary_title secondary_cap">
                  {{  $t('cart.total').toLowerCase() }}
                </div>
                <div style="margin-left: 8px;">
                  <v-selectprice
                    :price="complete_subtotal"
                    :disable_select="!(showCurrencySelector && currencySelectorType == 'global')"
                    :country="$store.state.pricetype ||''"
                    fontSize="14"
                    :appendToBody="false"
                  ></v-selectprice>
                </div>
              </div>
            </div>
            <div class="shopping-carbody-list-foot-tip page_text_font">
              {{ $t("cart.Taxes_shipping_checkout") }}
            </div>
            <div class="checkoutbox text-md-right text-center">
              <!-- <div class="col-md-5 col-12 offset-md-7 text-md-right text-center">
                <p style="margin:15px 0 0;">Tax included and shipping calculated at checkout</p>
              </div>-->
              <button
                class="checkout secondary_title main_button"
                :class="[{ button_active: checkout_active },themeStyleRadius == 'circle' ? 'button-radius' : '']"
                :disabled="checkout_active"
                type="button"
                @click="checkouts"
              >
                {{ $t("cart.check_out") }} →
              </button>
            </div>
            <div
              class="row"
              v-if="
                (paypalposition == 'cart' || paypalposition == 'both') &&
                paypal_enabled &&
                paypal_enabled != 'none'
              "
              style="z-index: 1; position: relative;justify-content:flex-end;"
            >
              <div class="paypal_botton col-12">
                <v-paypal-btn
                  style="margin-top: 15px"
                  :cartmes="JSON.stringify(cartmes)"
                ></v-paypal-btn>
              </div>
            </div>
          </div>
          <div class="note_box">
            <v-cartnote
              style="width:100%"
              v-if="cart_note_off"
              :cart_note="this.cart.cart_note"
              wrap_class="cart_note_page"
            ></v-cartnote>
          </div>
        </div>
      </div>
      <div class="col-md-10 offset-md-1 col-12" style="margin-top: 30px">
        <v-guess-like
          :comment="comment"
          v-if="recommended_product && show_recommended"
          :recommended_product="recommended_product"
          :cart_type="cart_type"
          :hide_container="true"
          :product_id="product_ids"
          :show_currency_selector="false"
          style="margin-bottom: 10px"
          theme="Brooklyn"
          :palette_config="palette_config"
        ></v-guess-like>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import vGuessLike from '@/js/components/view/guesslike/guesslike';
import vCartnote from "@/js/components/common/cartnote.vue";
import myElInputNumber from "@/js/components/myElement/myElInputNumber.vue"

export default {
  props: [
    "comment",
    "cart",
    "paypalposition",
    "error",
    "pixel_conversion",
    "current_theme",
    "cart_note_off",
    "paypal_enabled",
    "recommended_product",
    "cart_type",
    "palette_config",
  ],
  data() {
    return {
      // defaultImage,
      cartmes: "",
      checkout_active: false,
      show_car: true,
      disabled_num: false,
    };
  },
  computed: {
    ...mapState({
      showCurrencySelector: ({ options }) => options?.theme?.global?.show_currency_selector,
      currencySelectorType: ({ options }) => options?.theme?.global?.currency_selector_type,
      themeStyleRadius: ({ options }) => options?.theme?.global?.style?.type || "",
    }),

    product_ids() {
      if (!this.cartmes.cart) return;
      let products = Object.values(this.cartmes.cart);
      let ids = [];
      if (!products.length) return "";
      products.forEach((item) => {
        ids.push(item.product_id);
      });
      return ids.join(",");
    },
    complete_subtotal() {
      let subtotal = this.cartmes.cart_total - this.cartmes.shipping_total;
      if (
        this.cartmes.fees &&
        this.cartmes.fees["shipping-insurance"] &&
        this.cartmes.fees["shipping-insurance"].amount
      ) {
        subtotal = subtotal - this.cartmes.fees["shipping-insurance"].amount;
      }
      return subtotal;
    },
  },
  methods: {
    async changequantity(quantity, key, product_id, variant_id) {
      if (this.disabled_num) return;
      this.disabled_num = true;
      quantity = this.filterinputnum(quantity, 0);
      this.cartmes.cart[key].quantity = quantity;
      let product_argument = variant_id
        ? { quantity, product_id, variant_id }
        : { quantity, product_id };
      try {
        var res = await this.$axios.put(
          API.changequantity + key,
          {...product_argument,tag:'store'}
        );
        this.disabled_num = false;
        this.cartmes = res.data;
        this.$store.dispatch("cartContentsCount", res.data.cart_contents_count);
        localStorage.setItem("cartContentsCount", res.data.cart_contents_count);
      } catch (error) {
        this.disabled_num = false;
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else if (
          error?.response?.data?.message
        ) {
          this.$message.error(error.response.data.message);
        }
      }
    },
    checkouts() {
      this.checkout_active = true;
      let cart_hash = this.getCookie("cart_hash");
      if (window.fbq) {
        let cart_item = Object.values(this.cartmes.cart);
        let content_ids = [];
        let product_category_ids = [];
        cart_item.forEach((item) => {
          content_ids.push(item.product_id);
          if (item.category_ids) {
            product_category_ids = product_category_ids.concat(
              item.category_ids
            );
          }
        });
        if (
          this.pixel_conversion &&
          this.pixel_conversion.pixel_conversion &&
          this.pixel_conversion.pixel_conversion.length &&
          product_category_ids.length
        ) {
          this.initFBevent(
            this.pixel_conversion.pixel_conversion,
            product_category_ids
          );
        }
        console.log("content_ids", content_ids);
        this.send_fb_event("InitiateCheckout", {
          content_type: "product_group",
          content_ids,
          value: this.cartmes.cart_total,
          num_items: this.cartmes.cart_contents_count,
          currency: this.cartmes.currency ? this.cartmes.currency : "USD",
        });
      }
      if (window.ttq && window.send_ttp_event) {
        window.send_ttp_event('InitiateCheckout')
      }
      if (window._learnq) {
        this.klaviyo_checkout(this.cartmes);
      }
      this.$axios.post(API.statis_event, {
        name: "cart.check",
        parameters: { url: window.location.href },
      });
      this.$axios.post(API.statis_event, {
        name: "checkout.check",
        parameters: { url: window.location.href },
      });
      // if (window.gtag) {
      //   window.gtag("event", "cart.check", {
      //     event_category: "ecommerce",
      //   });
      // }
      // if (window.snaptr) {
      //     window.snaptr('track', 'START_CHECKOUT', {
      //         'currency': this.cartmes.currency ? this.cartmes.currency : "USD",
      //         'item_category': null,
      //         'item_ids': this.content_ids,
      //         'number_items': this.cartmes.cart_contents_count,
      //         'price': this.cartmes.cart_total,
      //     })
      // }
      setTimeout(() => {
        this.checkout_active = false;
      }, 5000);
      this.toCheckInfo(cart_hash);
      // window.open(`/checkouts/${cart_hash}`, "_self");
    },
  },
  async beforeMount() {
    console.log(this.current_theme);
    if (
      !window.fbq &&
      this.pixel_conversion &&
      this.pixel_conversion.pixel_conversion
    ) {
      this.FBevent();
    }
    this.cartmes = this.cart;
    this.cart_notices(this.cart, this);
    this.$store.dispatch("cartContentsCount", this.cartmes.cart_contents_count);
    localStorage.setItem("cartContentsCount", this.cartmes.cart_contents_count);
    // window.addEventListener("popstate", e => {
    // this.checkout_active = false;
    // });
    console.log(this.cartmes);
    console.log("error", this.error);
    if (window.performance.navigation.type == 2) {
      this.show_car = false
      this.bus.$on('customGetCart', (res) => {
        this.show_car = true
      })
    }
    if (this.recommended_product) {
      this.show_recommended = this.recommended_product.shopCart == 1;
    }
  },
  watch: {
    "$store.state.news_cart"() {
      console.log("cart  store.state.news_cart", this.$store.state.news_cart);
      this.cartmes = this.$store.state.news_cart;
    },
  },
  components: {
    vGuessLike,
    vCartnote,
    myElInputNumber
  },
};
</script>
<style  lang='scss'>
.free-box {
  background: #fafafa;
  padding: 10px 0;
  .col-md-2,.col-md-5 {
    display: none !important;
  }
  .free-item {
     width: 280px;
     min-height: 90px;
     margin-left: 15px;
     display: flex;
     align-content: center;
     background: #fff;
     .free-label {
      position: absolute;
      width: 70px;
      color:#fff;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 3px;
      box-sizing: border-box;
      border-radius: 28px;
      font-size: 9px;
     }
     .image-box {
      width: 90px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 15px;
      margin-left: 10px;
      padding: 10px 0;
      a {
        display: flex;
        align-items: center;
        width: 70px;
        height: 100%;
        img {
          width: 100%;
          max-height: 100%;
        }
      }
    }
    .text-box{
      display: flex;
      align-items: baseline;
      flex-direction: column;
      justify-content: space-evenly;
      width: 100%;
      font-size: 12px;
      padding: 6px;
      .variant {
        text-align: left;
        margin-bottom: 0;
        & > span:not(:last-child)::after {
          content: " / ";
        }
      }
      .text-item {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      text-overflow: -o-ellipsis-lastline;
      }
      #free-price {
          .product_price_price {
          .money {
            font-size: 12px !important;
            color: #222222 !important;
            line-height: 30px;
          }
        }
      }
    }
  }
}
.shoppingcar {
  margin-top: 80px;
  margin-bottom: 40px;
  position: relative;
  a{
    color: inherit;
  }
  .shoppingcarbody {
    text-align: center;

    h2 {
      font-size: 26px;
      color: #222323;
    }

    .shoppingcarbodylist {
      margin-top: 50px;
      .shoppingcarbodylisthead {
        border-bottom: 1px solid black;
        padding-bottom: 10px;
        margin-bottom: 30px;
        white-space: nowrap;
        .col-2, .col-3{
          text-transform:uppercase
        }
      }

      .shoppingcarbodylistitem {
        margin-bottom: 30px;
        align-items: center;
        .text-left {
          p:first-child:hover {
            text-decoration: underline;
          }
        }
        // .commoditynum {
        //   width: 100%;
        //   height: 26px;
        //   box-sizing: border-box;
        //   padding: 8px 10px;
        //   box-sizing: content-box;
        //   border: none;
        //   background-color: #f6f6f6;
        //   text-align: center;
        // }
        .numprice {
          a {
            text-decoration: none;
            color: black;
          }
          .button-radius.el-input-number {
            border: 1px solid #DCDFE6;
              .el-input {
                .el-input__inner  {
                  border: 0 !important;
                }
            }
          }
          .selet_sm {
            #discount_price {
              display: flex;
              flex-direction: column;
              .product_price_price {
                .money {
                  font-size: 14px !important;
                  color: #000 !important;
                  text-decoration: line-through;
                  line-height: 30px;
                }

              }
            }
          }
          .el-input-number {
            width: 120px;
            .el-input-number__decrease,
            .el-input-number__increase {
              width: 33.33%;
              background: unset !important;
              i {
                font-weight: 600 !important;
              }
              &:hover {
                background-color: #e9e9e9 !important;
                color: #1c1d1d !important;
              }
            }
            .el-input {
              .el-input__inner {
                font-size: 18px;
                // background-color: #f6f6f6 !important ;
                padding: 5px 33.33% !important;
                border: 1px solid #dcdfe6 !important;
              }
            }
          }
          .is-disabled {
            .el-input-number__decrease,
            .el-input-number__increase {
              &:hover {
                background-color: unset !important;
                color: #e4e7ed !important;
              }
            }
          }
        }

        & > div:nth-child(2) {
          color: black;
          &>a {
            text-decoration: none;
            color: black;
            p {
              font-size: 16px;
              margin-bottom: 8px;
              color: black;
            }
            .variant {
              font-size: 12px;
              color: #717171;
              & > span:not(:last-child)::after {
                content: " / ";
              }
              .preview:hover {
                opacity: 0.7;
                cursor: pointer;
              }
            }
          }
        }
      }
      .foot {
        padding-top: 16px;
        border-top: 1px solid black;
        .shoppingcarbodylistfoot {
          height: 35px;
          align-items: center;
          .currency-tips {
            color: rgba(0, 0, 0, 0.65);
            border: 1px solid #ffe58f;
            background-color: #fffbe6;
            padding: 8px 12px;
            margin-bottom: 12px;
          }

          .subtotal {
            font-weight: 500;
            font-size: 14px;
            font-style: normal;
            letter-spacing: 0.1em;
            line-height: 28px;
            text-transform: uppercase;
          }
          .secondary_unset{
            text-transform: unset;
          }
          .secondary_cap{
            text-transform: capitalize;
            font-weight: 600;
          }
          .secondary-minus {
            .price_text{
              &::before {
                content: "-";
              }
            }
          }
        }
        .default_shoppingcarbodylistfoot{
          padding-top: 10px;
          border-top: 1px solid #DDDDDD;
          margin-bottom: 20px;
          font-weight: 600;
        }
        .only_default_shoppingcarbodylistfoot{
          border: none;
        }
        .checkoutbox {
          text-align: right;
          .checkout {
            display: inline-block;
            padding: 12px 20px;
            border: none;
            background: rgb(201, 13, 13) !important;
            color: white;
            font-weight: 600;
            font-style: normal;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            font-size: 14px;
            margin-top: 15px;
            border-radius: 0;
            cursor: pointer;
            width: 100%;
            height: 44px;
            &:hover {
              background: rgb(241, 34, 34) !important;
            }
          }
        }
        .checkout:hover {
            filter: opacity(80%);
        }
        .button_active{
            filter: opacity(60%);
        }
      }
    }
  }
}

.shopping-carbody-list-foot-tip {
  font-size: 14px;
  text-align: right;
  text-transform: initial;
  word-wrap: break-word;
  margin: 10px 0;
  line-height: 1.5;
  // max-width: 240px;
}

@media screen and (max-width: 768px) {
  .shoppingcar {
    margin-top: 30px !important;
    margin-bottom: -10px !important;
    .shoppingcarbody {
      .shoppingcarbodylist {
        margin-top: 10px !important;
        .shoppingcarbodylistitem {
          .numprice {
            .el-input-number {
              width: 90px;
              height: 30px;
              line-height: 30px;
              margin-bottom: 6px;
              .el-input .el-input__inner {
                height: 30px;
                line-height: 30px;
              }
            }
          }
        }
        .foot {
          display: flex;
          justify-items: center;
          flex-direction: column-reverse;
          .selectpricewrap {
            .pricelistbox {
              right: 30px;
            }
          }
          .note_box{
            position: relative;
            width: 100%;
            margin-top:-16px;
          }
          .checkoutbox {
            .checkout {
              width: 100%;
            }
          }
        }
      }
    }
    .shoppingcarbodylisthead {
      display: none;
    }
  }

  .shoppingcarbodylistfoot {
    margin: 0;
  }

  .shoppingcarbodylistitem {
    align-items: stretch !important;
    .selectpricewrap {
      .pricelistbox {
        right: 45px;
      }
    }
  }

  .numprice {
    padding-top: 8px !important;
    .el-input-number {
        width: 100%;
    }
  }
  .row_sm {
    display: flex;
    justify-content: space-between;
     .total_sm {
      text-align: left;
      margin-left: 0;
      order: -2;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      width: 100%;
    }
    .selet_sm {
      display: flex;
      align-items: flex-end;
      flex-direction: column;
      margin-left: 0;
      order: -1;
      width: unset;
      #discount_price {
              &::v-deep {
          .product_price_price {
            .money {
              font-size: 14px !important;
              color: #8e929e !important;
            }
          }
        }
      }
    }
  }
  .venue {
    margin-bottom: 20px !important;
  }
  .paypal_botton {
    flex: unset;
    max-width: unset;

  }
}

@media (min-width: 768px) {
  .shoppingcarbodylisthead {
    display: flex;
    // text-align: right;
    flex-wrap: nowrap;
    .col-3 {
      padding-right: 0;
    }
  }
  .foot {
    display: flex;
    justify-content: space-between;
    justify-items: flex-end;
    flex-direction: row-reverse;
    >div:nth-child(1) {
      margin-left: 10px;
    }
    .note_box{
      position: relative;
      width: calc(100% - 300px);
      margin-top:-16px;
      max-width: 420px;
    }
  }
  // .paypal_botton {
  //   flex: 0 0 41.6666666667%;
  //   max-width: 270px;
  //   .paypal-button-render {
  //     width: 240px;
  //   }
  // }
  .total_sm {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
}

.cartEmpty {
  margin: 80px auto;
  width: max-content;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  &--image {
    margin-bottom: 20px;
  }
}

</style>
